

















































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Period from "@/models/annoucement/period.Model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";
import AnnoucementType from "@/models/annoucement/annoucementType.model";
@Component
export default class AnnoucementTypeComponent extends GenericBTable<
  AnnoucementType
> {
  created() {
    this.permissionValue = PermissionValue.ANNOUCEMENTTYPE;
    this.tableConfig.controller = "AnnoucementType";
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.name", true);
    let code = new BTableColumn("code", "table.code", true);
    this.tableConfig.insertColumns(name, code);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }
}
